export default {
  features: {
    registration: {
      title: 'Регистрация',
      askAccount: ['Уже есть аккаунт?', 'Войдите здесь'],
      username: {
        label: 'Ваше Ф.И.О.',
        placeholder: 'Ваше Ф.И.О.',
      },
      userPhone: {
        label: 'Ваш номер телефона',
        placeholder: '(99) 999-99-99',
      },
      name: {
        label: 'Название магазина',
        placeholder: 'Введите название магазина',
      },
      tin: {
        label: 'Идентификационный номер налогоплательщика (ИНН)',
        placeholder: 'Идентификационный номер налогоплательщика (ИНН)',
        select: 'ИНН',
      },
      pinfl: {
        label: 'ПИНФЛ',
        placeholder: 'ПИНФЛ',
        select: 'Пинфл',
      },
      prev: 'Назад',
      complete: 'Завершить',
    },
  },
};
